import { AssessmentType } from "../../../types/Assessment";
import { ClassType } from "../../../types/Class";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { ASSESSMENTS, ASSESSMENTS_STUDENT, CLASSES } from "../../../utils/constants";

export const getAssessments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams();

    queryParams.append('PageNumber', data?.PageNumber?.toString() || '1');
    queryParams.append('PageSize', data?.PageSize?.toString() || '100');

    if (data?.IdClass) {
        queryParams.append('IdClass', data.IdClass);
    }
    if (data?.IdTeacher) {
        queryParams.append('IdTeacher', data.IdTeacher.toString());
    }
    if (data?.Semester) {
        queryParams.append('Semester', data.Semester.toString());
    }
    if (data?.IdSubject) {
        queryParams.append('IdSubject', data.IdSubject.toString());
    }
    if (data?.IdAcademicYear) {
        queryParams.append('IdAcademicYear', data.IdAcademicYear.toString());
    }
    const url = `${ASSESSMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<AssessmentType>>(url)
}; 
export const getStudentMyAssessments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams();

    queryParams.append('PageNumber', data?.PageNumber?.toString() || '1');
    queryParams.append('PageSize', data?.PageSize?.toString() || '100');

    if (data?.IdClass) {
        queryParams.append('IdClass', data.IdClass);
    }
    if (data?.IdTeacher) {
        queryParams.append('IdTeacher', data.IdTeacher.toString());
    }
    if (data?.Semester) {
        queryParams.append('Semester', data.Semester.toString());
    }
    if (data?.IdSubject) {
        queryParams.append('IdSubject', data.IdSubject.toString());
    }
    if (data?.IdAcademicYear) {
        queryParams.append('IdAcademicYear', data.IdAcademicYear.toString());
    }
    const url = `${ASSESSMENTS_STUDENT}?${queryParams.toString()}`;
    return await get<PagedResultsType<AssessmentType>>(url)
}; 